// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"b97fdb96","134":"9d09b0ba","159":"f9fdda18","160":"da01234f","238":"1b49afc2","257":"de6f9f01","328":"7a982d3f","397":"e981930a","433":"a017c2ab","441":"3270a43c","472":"b841b942","752":"a4c9ec08","753":"f304114e","869":"c3137332","912":"1913b8d4"}[chunkId] + ".chunk.js";
};